import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

import Home from "./pages/Home";
import About from "./pages/About";
import GetInvolved from "./pages/GetInvolved";

function App() {
  return (
    <Router>
      <div className="min-h-screen text-sienna bg-offwhite">
        {/* Navigation Bar */}
        <nav className="bg-lighttan shadow-md py-4 px-6 flex justify-between items-center">
          <div className="flex items-center gap-2">
            <img src="/logo.svg" alt="Logo" className="w-10 h-10" />
            <span className="text-xl font-bold text-olive">Common Roots Composting</span>
          </div>
          <div className="space-x-4 text-sm text-gray-600">
            <Link to="/" className="hover:text-olive">Home</Link>
            <Link to="/about" className="hover:text-olive">About</Link>
            <Link to="/get-involved" className="hover:text-olive">Get Involved</Link>
          </div>
        </nav>

        {/* Page Routes */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/get-involved" element={<GetInvolved />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
